var De = Object.defineProperty, ze = Object.defineProperties;
var Ee = Object.getOwnPropertyDescriptors;
var $ = Object.getOwnPropertySymbols;
var ae = Object.prototype.hasOwnProperty, ue = Object.prototype.propertyIsEnumerable;
var ie = (e, o, r) => o in e ? De(e, o, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[o] = r, b = (e, o) => {
  for (var r in o || (o = {}))
    ae.call(o, r) && ie(e, r, o[r]);
  if ($)
    for (var r of $(o))
      ue.call(o, r) && ie(e, r, o[r]);
  return e;
}, S = (e, o) => ze(e, Ee(o));
var P = (e, o) => {
  var r = {};
  for (var t in e)
    ae.call(e, t) && o.indexOf(t) < 0 && (r[t] = e[t]);
  if (e != null && $)
    for (var t of $(e))
      o.indexOf(t) < 0 && ue.call(e, t) && (r[t] = e[t]);
  return r;
};
import { jsx as m, jsxs as We } from "react/jsx-runtime";
import { useRef as D, useEffect as A, useMemo as Le, useCallback as He, forwardRef as T, useState as w } from "react";
import { n as Me } from "./floating-ui.react-DiT1zkFi.js";
import { r as Ve } from "./rem-CMQJ_ZTp.js";
import { c as Xe } from "./create-vars-resolver-Bzbn9G-G.js";
import { u as te, B as j, f as he } from "./factory-ueRxoNOV.js";
import { u as Ye } from "./use-styles-DToiHEa6.js";
import { c as fe } from "./create-safe-context-DqDyoPVE.js";
import { u as Ne } from "./use-isomorphic-effect-CiIycTKV.js";
import { u as F } from "./use-merged-ref-n551Tfbr.js";
import { u as Ue } from "./DirectionProvider-CT8S13Cp.js";
import { t as q } from "./to-int-CHbRl5M-.js";
function N(e) {
  const o = D(e);
  return A(() => {
    o.current = e;
  }), Le(() => (...r) => {
    var t;
    return (t = o.current) == null ? void 0 : t.call(o, ...r);
  }, []);
}
function G(e, o) {
  const r = typeof o == "number" ? o : o.delay, t = typeof o == "number" ? !1 : o.flushOnUnmount, s = N(e), n = D(0), l = D(() => {
  }), c = Object.assign(
    He(
      (...i) => {
        window.clearTimeout(n.current);
        const u = () => {
          n.current !== 0 && (n.current = 0, s(...i));
        };
        l.current = u, c.flush = u, n.current = window.setTimeout(u, r);
      },
      [s, r]
    ),
    { flush: l.current }
  );
  return A(
    () => () => {
      window.clearTimeout(n.current), t && c.flush();
    },
    [c, t]
  ), c;
}
const [Oe, R] = fe(
  "ScrollArea.Root component was not found in tree"
);
function B(e, o) {
  const r = N(o);
  Ne(() => {
    let t = 0;
    if (e) {
      const s = new ResizeObserver(() => {
        cancelAnimationFrame(t), t = window.requestAnimationFrame(r);
      });
      return s.observe(e), () => {
        window.cancelAnimationFrame(t), s.unobserve(e);
      };
    }
  }, [e, r]);
}
const Be = T((e, o) => {
  const h = e, { style: r } = h, t = P(h, ["style"]), s = R(), [n, l] = w(0), [c, i] = w(0), u = !!(n && c);
  return B(s.scrollbarX, () => {
    var a;
    const d = ((a = s.scrollbarX) == null ? void 0 : a.offsetHeight) || 0;
    s.onCornerHeightChange(d), i(d);
  }), B(s.scrollbarY, () => {
    var a;
    const d = ((a = s.scrollbarY) == null ? void 0 : a.offsetWidth) || 0;
    s.onCornerWidthChange(d), l(d);
  }), u ? /* @__PURE__ */ m("div", S(b({}, t), { ref: o, style: S(b({}, r), { width: n, height: c }) })) : null;
}), Fe = T((e, o) => {
  const r = R(), t = !!(r.scrollbarX && r.scrollbarY);
  return r.type !== "scroll" && t ? /* @__PURE__ */ m(Be, S(b({}, e), { ref: o })) : null;
}), ke = {
  scrollHideDelay: 1e3,
  type: "hover"
}, be = T((e, o) => {
  const C = te("ScrollAreaRoot", ke, e), { type: t, scrollHideDelay: s, scrollbars: n } = C, l = P(C, ["type", "scrollHideDelay", "scrollbars"]), [c, i] = w(null), [u, h] = w(null), [d, a] = w(null), [p, f] = w(null), [y, g] = w(null), [x, W] = w(0), [z, V] = w(0), [E, O] = w(!1), [L, X] = w(!1), v = F(o, (H) => i(H));
  return /* @__PURE__ */ m(
    Oe,
    {
      value: {
        type: t,
        scrollHideDelay: s,
        scrollArea: c,
        viewport: u,
        onViewportChange: h,
        content: d,
        onContentChange: a,
        scrollbarX: p,
        onScrollbarXChange: f,
        scrollbarXEnabled: E,
        onScrollbarXEnabledChange: O,
        scrollbarY: y,
        onScrollbarYChange: g,
        scrollbarYEnabled: L,
        onScrollbarYEnabledChange: X,
        onCornerWidthChange: W,
        onCornerHeightChange: V
      },
      children: /* @__PURE__ */ m(
        j,
        S(b({}, l), {
          ref: v,
          __vars: {
            "--sa-corner-width": n !== "xy" ? "0px" : `${x}px`,
            "--sa-corner-height": n !== "xy" ? "0px" : `${z}px`
          }
        })
      )
    }
  );
});
be.displayName = "@mantine/core/ScrollAreaRoot";
function me(e, o) {
  const r = e / o;
  return Number.isNaN(r) ? 0 : r;
}
function J(e) {
  const o = me(e.viewport, e.content), r = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, t = (e.scrollbar.size - r) * o;
  return Math.max(t, 18);
}
function pe(e, o) {
  return (r) => {
    if (e[0] === e[1] || o[0] === o[1])
      return o[0];
    const t = (o[1] - o[0]) / (e[1] - e[0]);
    return o[0] + t * (r - e[0]);
  };
}
function _e(e, [o, r]) {
  return Math.min(r, Math.max(o, e));
}
function de(e, o, r = "ltr") {
  const t = J(o), s = o.scrollbar.paddingStart + o.scrollbar.paddingEnd, n = o.scrollbar.size - s, l = o.content - o.viewport, c = n - t, i = r === "ltr" ? [0, l] : [l * -1, 0], u = _e(e, i);
  return pe([0, l], [0, c])(u);
}
function Ie(e, o, r, t = "ltr") {
  const s = J(r), n = s / 2, l = o || n, c = s - l, i = r.scrollbar.paddingStart + l, u = r.scrollbar.size - r.scrollbar.paddingEnd - c, h = r.content - r.viewport, d = t === "ltr" ? [0, h] : [h * -1, 0];
  return pe([i, u], d)(e);
}
function Se(e, o) {
  return e > 0 && e < o;
}
function U(e, o, { checkForDefaultPrevented: r = !0 } = {}) {
  return (t) => {
    e == null || e(t), (r === !1 || !t.defaultPrevented) && (o == null || o(t));
  };
}
const [$e, ve] = fe(
  "ScrollAreaScrollbar was not found in tree"
), we = T((e, o) => {
  const X = e, {
    sizes: r,
    hasThumb: t,
    onThumbChange: s,
    onThumbPointerUp: n,
    onThumbPointerDown: l,
    onThumbPositionChange: c,
    onDragScroll: i,
    onWheelScroll: u,
    onResize: h
  } = X, d = P(X, [
    "sizes",
    "hasThumb",
    "onThumbChange",
    "onThumbPointerUp",
    "onThumbPointerDown",
    "onThumbPositionChange",
    "onDragScroll",
    "onWheelScroll",
    "onResize"
  ]), a = R(), [p, f] = w(null), y = F(o, (v) => f(v)), g = D(null), x = D(""), { viewport: W } = a, z = r.content - r.viewport, V = N(u), E = N(c), O = G(h, 10), L = (v) => {
    if (g.current) {
      const C = v.clientX - g.current.left, H = v.clientY - g.current.top;
      i({ x: C, y: H });
    }
  };
  return A(() => {
    const v = (C) => {
      const H = C.target;
      (p == null ? void 0 : p.contains(H)) && V(C, z);
    };
    return document.addEventListener("wheel", v, { passive: !1 }), () => document.removeEventListener("wheel", v, { passive: !1 });
  }, [W, p, z, V]), A(E, [r, E]), B(p, O), B(a.content, O), /* @__PURE__ */ m(
    $e,
    {
      value: {
        scrollbar: p,
        hasThumb: t,
        onThumbChange: N(s),
        onThumbPointerUp: N(n),
        onThumbPositionChange: E,
        onThumbPointerDown: N(l)
      },
      children: /* @__PURE__ */ m(
        "div",
        S(b({}, d), {
          ref: y,
          "data-mantine-scrollbar": !0,
          style: b({ position: "absolute" }, d.style),
          onPointerDown: U(e.onPointerDown, (v) => {
            v.preventDefault(), v.button === 0 && (v.target.setPointerCapture(v.pointerId), g.current = p.getBoundingClientRect(), x.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", L(v));
          }),
          onPointerMove: U(e.onPointerMove, L),
          onPointerUp: U(e.onPointerUp, (v) => {
            const C = v.target;
            C.hasPointerCapture(v.pointerId) && (v.preventDefault(), C.releasePointerCapture(v.pointerId));
          }),
          onLostPointerCapture: () => {
            document.body.style.webkitUserSelect = x.current, g.current = null;
          }
        })
      )
    }
  );
}), ge = T(
  (e, o) => {
    const d = e, { sizes: r, onSizesChange: t, style: s } = d, n = P(d, ["sizes", "onSizesChange", "style"]), l = R(), [c, i] = w(), u = D(null), h = F(o, u, l.onScrollbarXChange);
    return A(() => {
      u.current && i(getComputedStyle(u.current));
    }, [u]), /* @__PURE__ */ m(
      we,
      S(b({
        "data-orientation": "horizontal"
      }, n), {
        ref: h,
        sizes: r,
        style: S(b({}, s), {
          "--sa-thumb-width": `${J(r)}px`
        }),
        onThumbPointerDown: (a) => e.onThumbPointerDown(a.x),
        onDragScroll: (a) => e.onDragScroll(a.x),
        onWheelScroll: (a, p) => {
          if (l.viewport) {
            const f = l.viewport.scrollLeft + a.deltaX;
            e.onWheelScroll(f), Se(f, p) && a.preventDefault();
          }
        },
        onResize: () => {
          u.current && l.viewport && c && t({
            content: l.viewport.scrollWidth,
            viewport: l.viewport.offsetWidth,
            scrollbar: {
              size: u.current.clientWidth,
              paddingStart: q(c.paddingLeft),
              paddingEnd: q(c.paddingRight)
            }
          });
        }
      })
    );
  }
);
ge.displayName = "@mantine/core/ScrollAreaScrollbarX";
const ye = T(
  (e, o) => {
    const d = e, { sizes: r, onSizesChange: t, style: s } = d, n = P(d, ["sizes", "onSizesChange", "style"]), l = R(), [c, i] = w(), u = D(null), h = F(o, u, l.onScrollbarYChange);
    return A(() => {
      u.current && i(window.getComputedStyle(u.current));
    }, []), /* @__PURE__ */ m(
      we,
      S(b({}, n), {
        "data-orientation": "vertical",
        ref: h,
        sizes: r,
        style: b({
          "--sa-thumb-height": `${J(r)}px`
        }, s),
        onThumbPointerDown: (a) => e.onThumbPointerDown(a.y),
        onDragScroll: (a) => e.onDragScroll(a.y),
        onWheelScroll: (a, p) => {
          if (l.viewport) {
            const f = l.viewport.scrollTop + a.deltaY;
            e.onWheelScroll(f), Se(f, p) && a.preventDefault();
          }
        },
        onResize: () => {
          u.current && l.viewport && c && t({
            content: l.viewport.scrollHeight,
            viewport: l.viewport.offsetHeight,
            scrollbar: {
              size: u.current.clientHeight,
              paddingStart: q(c.paddingTop),
              paddingEnd: q(c.paddingBottom)
            }
          });
        }
      })
    );
  }
);
ye.displayName = "@mantine/core/ScrollAreaScrollbarY";
const K = T((e, o) => {
  const p = e, { orientation: r = "vertical" } = p, t = P(p, ["orientation"]), { dir: s } = Ue(), n = R(), l = D(null), c = D(0), [i, u] = w({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), h = me(i.viewport, i.content), d = S(b({}, t), {
    sizes: i,
    onSizesChange: u,
    hasThumb: h > 0 && h < 1,
    onThumbChange: (f) => {
      l.current = f;
    },
    onThumbPointerUp: () => {
      c.current = 0;
    },
    onThumbPointerDown: (f) => {
      c.current = f;
    }
  }), a = (f, y) => Ie(f, c.current, i, y);
  return r === "horizontal" ? /* @__PURE__ */ m(
    ge,
    S(b({}, d), {
      ref: o,
      onThumbPositionChange: () => {
        if (n.viewport && l.current) {
          const f = n.viewport.scrollLeft, y = de(f, i, s);
          l.current.style.transform = `translate3d(${y}px, 0, 0)`;
        }
      },
      onWheelScroll: (f) => {
        n.viewport && (n.viewport.scrollLeft = f);
      },
      onDragScroll: (f) => {
        n.viewport && (n.viewport.scrollLeft = a(f, s));
      }
    })
  ) : r === "vertical" ? /* @__PURE__ */ m(
    ye,
    S(b({}, d), {
      ref: o,
      onThumbPositionChange: () => {
        if (n.viewport && l.current) {
          const f = n.viewport.scrollTop, y = de(f, i);
          i.scrollbar.size === 0 ? l.current.style.setProperty("--thumb-opacity", "0") : l.current.style.setProperty("--thumb-opacity", "1"), l.current.style.transform = `translate3d(0, ${y}px, 0)`;
        }
      },
      onWheelScroll: (f) => {
        n.viewport && (n.viewport.scrollTop = f);
      },
      onDragScroll: (f) => {
        n.viewport && (n.viewport.scrollTop = a(f));
      }
    })
  ) : null;
});
K.displayName = "@mantine/core/ScrollAreaScrollbarVisible";
const ne = T(
  (e, o) => {
    const r = R(), u = e, { forceMount: t } = u, s = P(u, ["forceMount"]), [n, l] = w(!1), c = e.orientation === "horizontal", i = G(() => {
      if (r.viewport) {
        const h = r.viewport.offsetWidth < r.viewport.scrollWidth, d = r.viewport.offsetHeight < r.viewport.scrollHeight;
        l(c ? h : d);
      }
    }, 10);
    return B(r.viewport, i), B(r.content, i), t || n ? /* @__PURE__ */ m(
      K,
      S(b({
        "data-state": n ? "visible" : "hidden"
      }, s), {
        ref: o
      })
    ) : null;
  }
);
ne.displayName = "@mantine/core/ScrollAreaScrollbarAuto";
const Pe = T(
  (e, o) => {
    const c = e, { forceMount: r } = c, t = P(c, ["forceMount"]), s = R(), [n, l] = w(!1);
    return A(() => {
      const { scrollArea: i } = s;
      let u = 0;
      if (i) {
        const h = () => {
          window.clearTimeout(u), l(!0);
        }, d = () => {
          u = window.setTimeout(() => l(!1), s.scrollHideDelay);
        };
        return i.addEventListener("pointerenter", h), i.addEventListener("pointerleave", d), () => {
          window.clearTimeout(u), i.removeEventListener("pointerenter", h), i.removeEventListener("pointerleave", d);
        };
      }
    }, [s.scrollArea, s.scrollHideDelay]), r || n ? /* @__PURE__ */ m(
      ne,
      S(b({
        "data-state": n ? "visible" : "hidden"
      }, t), {
        ref: o
      })
    ) : null;
  }
);
Pe.displayName = "@mantine/core/ScrollAreaScrollbarHover";
const je = T(
  (e, o) => {
    const u = e, { forceMount: r } = u, t = P(u, ["forceMount"]), s = R(), n = e.orientation === "horizontal", [l, c] = w("hidden"), i = G(() => c("idle"), 100);
    return A(() => {
      if (l === "idle") {
        const h = window.setTimeout(() => c("hidden"), s.scrollHideDelay);
        return () => window.clearTimeout(h);
      }
    }, [l, s.scrollHideDelay]), A(() => {
      const { viewport: h } = s, d = n ? "scrollLeft" : "scrollTop";
      if (h) {
        let a = h[d];
        const p = () => {
          const f = h[d];
          a !== f && (c("scrolling"), i()), a = f;
        };
        return h.addEventListener("scroll", p), () => h.removeEventListener("scroll", p);
      }
    }, [s.viewport, n, i]), r || l !== "hidden" ? /* @__PURE__ */ m(
      K,
      S(b({
        "data-state": l === "hidden" ? "hidden" : "visible"
      }, t), {
        ref: o,
        onPointerEnter: U(e.onPointerEnter, () => c("interacting")),
        onPointerLeave: U(e.onPointerLeave, () => c("idle"))
      })
    ) : null;
  }
), oe = T(
  (e, o) => {
    const i = e, { forceMount: r } = i, t = P(i, ["forceMount"]), s = R(), { onScrollbarXEnabledChange: n, onScrollbarYEnabledChange: l } = s, c = e.orientation === "horizontal";
    return A(() => (c ? n(!0) : l(!0), () => {
      c ? n(!1) : l(!1);
    }), [c, n, l]), s.type === "hover" ? /* @__PURE__ */ m(Pe, S(b({}, t), { ref: o, forceMount: r })) : s.type === "scroll" ? /* @__PURE__ */ m(je, S(b({}, t), { ref: o, forceMount: r })) : s.type === "auto" ? /* @__PURE__ */ m(ne, S(b({}, t), { ref: o, forceMount: r })) : s.type === "always" ? /* @__PURE__ */ m(K, S(b({}, t), { ref: o })) : null;
  }
);
oe.displayName = "@mantine/core/ScrollAreaScrollbar";
function qe(e, o = () => {
}) {
  let r = { left: e.scrollLeft, top: e.scrollTop }, t = 0;
  return function s() {
    const n = { left: e.scrollLeft, top: e.scrollTop }, l = r.left !== n.left, c = r.top !== n.top;
    (l || c) && o(), r = n, t = window.requestAnimationFrame(s);
  }(), () => window.cancelAnimationFrame(t);
}
const Ce = T((e, o) => {
  const h = e, { style: r } = h, t = P(h, ["style"]), s = R(), n = ve(), { onThumbPositionChange: l } = n, c = F(o, (d) => n.onThumbChange(d)), i = D(void 0), u = G(() => {
    i.current && (i.current(), i.current = void 0);
  }, 100);
  return A(() => {
    const { viewport: d } = s;
    if (d) {
      const a = () => {
        if (u(), !i.current) {
          const p = qe(d, l);
          i.current = p, l();
        }
      };
      return l(), d.addEventListener("scroll", a), () => d.removeEventListener("scroll", a);
    }
  }, [s.viewport, u, l]), /* @__PURE__ */ m(
    "div",
    S(b({
      "data-state": n.hasThumb ? "visible" : "hidden"
    }, t), {
      ref: c,
      style: b({
        width: "var(--sa-thumb-width)",
        height: "var(--sa-thumb-height)"
      }, r),
      onPointerDownCapture: U(e.onPointerDownCapture, (d) => {
        const p = d.target.getBoundingClientRect(), f = d.clientX - p.left, y = d.clientY - p.top;
        n.onThumbPointerDown({ x: f, y });
      }),
      onPointerUp: U(e.onPointerUp, n.onThumbPointerUp)
    })
  );
});
Ce.displayName = "@mantine/core/ScrollAreaThumb";
const re = T(
  (e, o) => {
    const n = e, { forceMount: r } = n, t = P(n, ["forceMount"]), s = ve();
    return r || s.hasThumb ? /* @__PURE__ */ m(Ce, b({ ref: o }, t)) : null;
  }
);
re.displayName = "@mantine/core/ScrollAreaThumb";
const Te = T(
  (s, t) => {
    var n = s, { children: e, style: o } = n, r = P(n, ["children", "style"]);
    const l = R(), c = F(t, l.onViewportChange);
    return /* @__PURE__ */ m(
      j,
      S(b({}, r), {
        ref: c,
        style: b({
          overflowX: l.scrollbarXEnabled ? "scroll" : "hidden",
          overflowY: l.scrollbarYEnabled ? "scroll" : "hidden"
        }, o),
        children: /* @__PURE__ */ m("div", { style: { minWidth: "100%" }, ref: l.onContentChange, children: e })
      })
    );
  }
);
Te.displayName = "@mantine/core/ScrollAreaViewport";
var le = { root: "m_d57069b5", viewport: "m_c0783ff9", viewportInner: "m_f8f631dd", scrollbar: "m_c44ba933", thumb: "m_d8b5e363", corner: "m_21657268" };
const xe = {
  scrollHideDelay: 1e3,
  type: "hover",
  scrollbars: "xy"
}, Ge = Xe(
  (e, { scrollbarSize: o, overscrollBehavior: r }) => ({
    root: {
      "--scrollarea-scrollbar-size": Ve(o),
      "--scrollarea-over-scroll-behavior": r
    }
  })
), Q = he((e, o) => {
  const r = te("ScrollArea", xe, e), ce = r, {
    classNames: t,
    className: s,
    style: n,
    styles: l,
    unstyled: c,
    scrollbarSize: i,
    vars: u,
    type: h,
    scrollHideDelay: d,
    viewportProps: a,
    viewportRef: p,
    onScrollPositionChange: f,
    children: y,
    offsetScrollbars: g,
    scrollbars: x,
    onBottomReached: W,
    onTopReached: z,
    overscrollBehavior: V
  } = ce, E = P(ce, [
    "classNames",
    "className",
    "style",
    "styles",
    "unstyled",
    "scrollbarSize",
    "vars",
    "type",
    "scrollHideDelay",
    "viewportProps",
    "viewportRef",
    "onScrollPositionChange",
    "children",
    "offsetScrollbars",
    "scrollbars",
    "onBottomReached",
    "onTopReached",
    "overscrollBehavior"
  ]), [O, L] = w(!1), [X, v] = w(!1), [C, H] = w(!1), M = Ye({
    name: "ScrollArea",
    props: r,
    classes: le,
    className: s,
    style: n,
    classNames: t,
    styles: l,
    unstyled: c,
    vars: u,
    varsResolver: Ge
  }), _ = D(null), Ae = Me([p, _]);
  return A(() => {
    if (!_.current || g !== "present")
      return;
    const Y = _.current, k = new ResizeObserver(() => {
      const { scrollHeight: Z, clientHeight: ee, scrollWidth: I, clientWidth: Re } = Y;
      v(Z > ee), H(I > Re);
    });
    return k.observe(Y), () => k.disconnect();
  }, [_, g]), /* @__PURE__ */ We(
    be,
    S(b(b({
      type: h === "never" ? "always" : h,
      scrollHideDelay: d,
      ref: o,
      scrollbars: x
    }, M("root")), E), {
      children: [
        /* @__PURE__ */ m(
          Te,
          S(b(b({}, a), M("viewport", { style: a == null ? void 0 : a.style })), {
            ref: Ae,
            "data-offset-scrollbars": g === !0 ? "xy" : g || void 0,
            "data-scrollbars": x || void 0,
            "data-horizontal-hidden": g === "present" && !C ? "true" : void 0,
            "data-vertical-hidden": g === "present" && !X ? "true" : void 0,
            onScroll: (Y) => {
              var I;
              (I = a == null ? void 0 : a.onScroll) == null || I.call(a, Y), f == null || f({ x: Y.currentTarget.scrollLeft, y: Y.currentTarget.scrollTop });
              const { scrollTop: k, scrollHeight: Z, clientHeight: ee } = Y.currentTarget;
              k - (Z - ee) >= -0.6 && (W == null || W()), k === 0 && (z == null || z());
            },
            children: y
          })
        ),
        (x === "xy" || x === "x") && /* @__PURE__ */ m(
          oe,
          S(b({}, M("scrollbar")), {
            orientation: "horizontal",
            "data-hidden": h === "never" || g === "present" && !C ? !0 : void 0,
            forceMount: !0,
            onMouseEnter: () => L(!0),
            onMouseLeave: () => L(!1),
            children: /* @__PURE__ */ m(re, b({}, M("thumb")))
          })
        ),
        (x === "xy" || x === "y") && /* @__PURE__ */ m(
          oe,
          S(b({}, M("scrollbar")), {
            orientation: "vertical",
            "data-hidden": h === "never" || g === "present" && !X ? !0 : void 0,
            forceMount: !0,
            onMouseEnter: () => L(!0),
            onMouseLeave: () => L(!1),
            children: /* @__PURE__ */ m(re, b({}, M("thumb")))
          })
        ),
        /* @__PURE__ */ m(
          Fe,
          S(b({}, M("corner")), {
            "data-hovered": O || void 0,
            "data-hidden": h === "never" || void 0
          })
        )
      ]
    })
  );
});
Q.displayName = "@mantine/core/ScrollArea";
const se = he((e, o) => {
  const E = te("ScrollAreaAutosize", xe, e), {
    children: r,
    classNames: t,
    styles: s,
    scrollbarSize: n,
    scrollHideDelay: l,
    type: c,
    dir: i,
    offsetScrollbars: u,
    viewportRef: h,
    onScrollPositionChange: d,
    unstyled: a,
    variant: p,
    viewportProps: f,
    scrollbars: y,
    style: g,
    vars: x,
    onBottomReached: W,
    onTopReached: z
  } = E, V = P(E, [
    "children",
    "classNames",
    "styles",
    "scrollbarSize",
    "scrollHideDelay",
    "type",
    "dir",
    "offsetScrollbars",
    "viewportRef",
    "onScrollPositionChange",
    "unstyled",
    "variant",
    "viewportProps",
    "scrollbars",
    "style",
    "vars",
    "onBottomReached",
    "onTopReached"
  ]);
  return /* @__PURE__ */ m(j, S(b({}, V), { ref: o, style: [{ display: "flex", overflow: "auto" }, g], children: /* @__PURE__ */ m(j, { style: { display: "flex", flexDirection: "column", flex: 1 }, children: /* @__PURE__ */ m(
    Q,
    {
      classNames: t,
      styles: s,
      scrollHideDelay: l,
      scrollbarSize: n,
      type: c,
      dir: i,
      offsetScrollbars: u,
      viewportRef: h,
      onScrollPositionChange: d,
      unstyled: a,
      variant: p,
      viewportProps: f,
      vars: x,
      scrollbars: y,
      onBottomReached: W,
      onTopReached: z,
      children: r
    }
  ) }) }));
});
Q.classes = le;
se.displayName = "@mantine/core/ScrollAreaAutosize";
se.classes = le;
Q.Autosize = se;
export {
  Q as S
};
